module.exports = __webpack_public_path__ + "img/machine-cpu.2521a4ed.svg";